// Validação de CPF
export const validarCPF = (cpf) => {
  // Remove caracteres não numéricos
  const cpfLimpo = cpf.replace(/\D/g, '');
  
  // Verifica se tem 11 dígitos
  if (cpfLimpo.length !== 11) {
    return { valido: false, mensagem: 'CPF deve conter 11 dígitos' };
  }
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cpfLimpo)) {
    return { valido: false, mensagem: 'CPF inválido' };
  }
  
  // Validação dos dígitos verificadores
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpfLimpo.charAt(i)) * (10 - i);
  }
  let digito1 = 11 - (soma % 11);
  if (digito1 >= 10) digito1 = 0;
  
  if (digito1 !== parseInt(cpfLimpo.charAt(9))) {
    return { valido: false, mensagem: 'CPF inválido' };
  }
  
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpfLimpo.charAt(i)) * (11 - i);
  }
  let digito2 = 11 - (soma % 11);
  if (digito2 >= 10) digito2 = 0;
  
  if (digito2 !== parseInt(cpfLimpo.charAt(10))) {
    return { valido: false, mensagem: 'CPF inválido' };
  }
  
  return { valido: true };
};

// Validação de Senha
export const validarSenha = (senha) => {
  if (!senha) {
    return { valido: false, mensagem: 'Senha é obrigatória' };
  }
  
  if (senha.length < 8) {
    return { valido: false, mensagem: 'Senha deve ter no mínimo 8 caracteres' };
  }
  
  if (!/[A-Z]/.test(senha)) {
    return { valido: false, mensagem: 'Senha deve conter pelo menos uma letra maiúscula' };
  }
  
  if (!/[a-z]/.test(senha)) {
    return { valido: false, mensagem: 'Senha deve conter pelo menos uma letra minúscula' };
  }
  
  if (!/[0-9]/.test(senha)) {
    return { valido: false, mensagem: 'Senha deve conter pelo menos um número' };
  }
  
  if (!/[^A-Za-z0-9]/.test(senha)) {
    return { valido: false, mensagem: 'Senha deve conter pelo menos um caractere especial' };
  }
  
  return { valido: true };
};

// Validação de Nome de Usuário
export const validarNomeUsuario = (nomeUsuario) => {
  if (!nomeUsuario) {
    return { valido: false, mensagem: 'Nome de usuário é obrigatório' };
  }
  
  if (nomeUsuario.length < 3) {
    return { valido: false, mensagem: 'Nome de usuário deve ter no mínimo 3 caracteres' };
  }
  
  if (nomeUsuario.length > 100) {
    return { valido: false, mensagem: 'Nome de usuário deve ter no máximo 100 caracteres' };
  }
  
  if (!/^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?$/.test(nomeUsuario)) {
    return { valido: false, mensagem: 'Nome de usuário inválido. Use apenas letras, números, ponto, underscore e hífen' };
  }
  
  if (nomeUsuario[0] === '.' || nomeUsuario[0] === '_' || nomeUsuario[0] === '-') {
    return { valido: false, mensagem: 'Nome de usuário não pode começar com ponto, underscore ou hífen' };
  }
  
  if (nomeUsuario[nomeUsuario.length - 1] === '.' || nomeUsuario[nomeUsuario.length - 1] === '_' || nomeUsuario[nomeUsuario.length - 1] === '-') {
    return { valido: false, mensagem: 'Nome de usuário não pode terminar com ponto, underscore ou hífen' };
  }
  
  if (nomeUsuario.includes('..')) {
    return { valido: false, mensagem: 'Nome de usuário não pode ter pontos consecutivos' };
  }
  
  return { valido: true };
};

// Formatar CPF
export const formatarCPF = (value) => {
  const numbers = value.replace(/\D/g, '');
  
  if (numbers.length <= 11) {
    return numbers
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }
  return value;
};




